module.exports = __webpack_public_path__ + "src/img/artist/work09_2.jpg?79ed13a9668124ee550af435d2dadb6a";


//////////////////
// WEBPACK FOOTER
// ./src/img/artist/work09_2.jpg
// module id = 164
// module chunks = 0